module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MP - Northern Mariana Islands.91f26721.svg";